export const BUTTON_SAVE_ABLE = 'BUTTON_SAVE_ABLE';
export const BUTTON_SAVE_DISABLE = 'BUTTON_SAVE_DISABLE';

export interface SaveButton {
  buttonSave: boolean
}